// extracted by extract-css-chunks-webpack-plugin
module.exports = {"language-selector":"LanguageSelector-1d4c9ef6d17fa951"};